/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Platform the order was created on and, if applicable, imported from.
 *
 * @remarks
 * Orders created via the Shippo API or dashboard will have the value "Shippo".
 */
export const OrderShopAppEnum = {
  Amazon: "Amazon",
  Bigcommerce: "Bigcommerce",
  CSVImport: "CSV_Import",
  EBay: "eBay",
  EPages: "ePages",
  Etsy: "Etsy",
  Godaddy: "Godaddy",
  Magento: "Magento",
  Shippo: "Shippo",
  Shopify: "Shopify",
  Spreecommerce: "Spreecommerce",
  StripeRelay: "StripeRelay",
  Walmart: "Walmart",
  Weebly: "Weebly",
  WooCommerce: "WooCommerce",
} as const;
/**
 * Platform the order was created on and, if applicable, imported from.
 *
 * @remarks
 * Orders created via the Shippo API or dashboard will have the value "Shippo".
 */
export type OrderShopAppEnum = ClosedEnum<typeof OrderShopAppEnum>;

/** @internal */
export const OrderShopAppEnum$inboundSchema: z.ZodNativeEnum<
  typeof OrderShopAppEnum
> = z.nativeEnum(OrderShopAppEnum);

/** @internal */
export const OrderShopAppEnum$outboundSchema: z.ZodNativeEnum<
  typeof OrderShopAppEnum
> = OrderShopAppEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace OrderShopAppEnum$ {
  /** @deprecated use `OrderShopAppEnum$inboundSchema` instead. */
  export const inboundSchema = OrderShopAppEnum$inboundSchema;
  /** @deprecated use `OrderShopAppEnum$outboundSchema` instead. */
  export const outboundSchema = OrderShopAppEnum$outboundSchema;
}
